/**
 * Copyright 2024 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */

export const isNameable = (item: unknown): item is { name?: string | undefined } => {
  return typeof item === 'object' && item !== null && 'name' in item;
};
